import React from 'react'
import { IconButton, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material'
import Loading from '../../../Component/Loading'
import useMuiCompontent from '../../../Hooks/useMuiCompontent'
import { NoRecordFound } from '../../../Component/NoRecordFound'
import { Peginationcomponent } from '../../../Component/Peginationcomponent'
import { IoMdAdd } from 'react-icons/io'
import { IoIosSearch } from "react-icons/io";
import { FiRefreshCcw } from 'react-icons/fi'
import useTableSorting from '../../../Hooks/useTableSorting'
import MoreVertIcon from '@mui/icons-material/MoreVert';
import UseInventory from './Hooks/useInventory'
import RequestInventory from './component/requestInventory'

const Inventory = () => {


    const { data, methods } = UseInventory()

    const {
        headCells,
        controller,
        Filter,
        TotalCount,
        loader,
        openModal,
        requestlist,
    } = data

    const {
        handleChangeFilter,
        HandleSearchList,
        handleOpenModal,
        handleClosedModal,
        setController,
        reset,
    } = methods

    const { EnhancedTableHead, order, orderBy, stableSort, getComparator, handleRequestSort } = useTableSorting(headCells)
    const { CustomButton } = useMuiCompontent()


    return (
        <>
            {loader && <Loading />}
            <div className=" py-2" style={{ height: "100%" }}>
                <div className='pb-2 d-flex justify-content-between ' style={{ borderBottom: "2px solid #ededed" }}>
                    <ul className="headerlist px-0">
                        <li className='me-2' style={{ width: "210px" }}> <input type="text" placeholder="Search" className="form-control filter_input" name='search' value={Filter?.search} onChange={handleChangeFilter} /> </li>

                        {/* <li className="me-2" style={{ width: 150 }}>
                            <SelectBox
                                placeholder="Select"
                                value={Filter?.archive}
                                name="archive"
                                keys="value"
                                label="label"
                                menuValeu="value"
                                handleChange={handleChangeFilter}
                                option={activeStatusOption}
                            />
                        </li>  */}
                        <li className='me-2'><CustomButton disabled={Filter?.disable_button} startIcon={<IoIosSearch />} variant="contained" onClick={HandleSearchList}>search</CustomButton></li>
                        <li className="me-2" >
                            <IconButton onClick={reset} size="small" aria-label="delete" disabled={Filter?.disable_button} style={{ color: "#000", cursor: "pointer" }}>
                                <FiRefreshCcw />
                            </IconButton>
                        </li>
                        <li><CustomButton startIcon={<IoMdAdd />} variant="contained" onClick={() => handleOpenModal("requestInventory")}>add new Request</CustomButton></li>
                    </ul>
                </div>
                <div className="row" >
                    <div className="col-12 h-100 pt-3">

                        <TableContainer   >
                            {requestlist.length === 0 && <div className="col-sm-12 mt-3 text-center " > <NoRecordFound /> </div>}
                            <Table
                                id="table_mui"
                                aria-labelledby="tableTitle"
                                size={"medium"}
                                aria-label="enhanced table" >
                                {
                                    requestlist?.length !== 0 && <EnhancedTableHead order={order} orderBy={orderBy} onRequestSort={handleRequestSort} rowCount={requestlist?.length} />
                                }
                                {/* {
                                    <EnhancedTableHead order={order} orderBy={orderBy} onRequestSort={handleRequestSort} />
                                } */}
                                <TableBody className="table_overflow_scroll" >
                                    {stableSort(requestlist, getComparator(order, orderBy)).map(
                                        (row, index) => {
                                            const labelId = `enhanced-table-checkbox-${index}`;
                                            return <React.Fragment key={index}><TableRow id="hover_tr" style={{ cursor: 'pointer' }}>
                                                <TableCell className="ps-3" component="th" id={labelId} scope="row" padding="none" >
                                                    {controller?.rowsPerPage * (controller?.page - 1) + index + 1}
                                                </TableCell>
                                                <TableCell id={labelId} align="left" >{row?.categoryName}</TableCell>
                                                <TableCell id={labelId} align="left" >{row?.batchNumber}</TableCell>
                                                <TableCell id={labelId} align="left" >{row?.productName}</TableCell>
                                                <TableCell id={labelId} align="left" >{row?.manufactureDate}</TableCell>
                                                <TableCell id={labelId} align="left" >{row?.expiryDate}</TableCell>
                                                <TableCell id={labelId} align="left" style={{ textWrap: "wrap" }}>{row?.quantity}</TableCell>
                                                {/* <TableCell id={labelId} align="right" ><MoreVertIcon type="button" data-bs-toggle="dropdown" aria-expanded="false" />
                                                    <ul className="dropdown-menu dropdown-menu-end me-3">
                                                        <li><button className="dropdown-item" onClick={() => handleOpenModal("requestInventory", row)}><i className="fa-solid fa-pen-to-square all_icons_color me-2 fs-6"></i>Edit Request</button></li>
                                                        <li><button className="dropdown-item" onClick={() => handleOpenModal("archive", row)}><BiArchiveIn className="all_react_icons_color me-2" />{`${row?.activeStatus === true ? "Archive" : "Unarchive"} Medicine`}</button></li>
                                                    </ul></TableCell> */}
                                            </TableRow>
                                            </React.Fragment>
                                        }
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>

                        <nav className=" w-100  " aria-label="pagination">
                            {TotalCount > 10 && <Peginationcomponent count={TotalCount} controller={controller} setController={setController} />}
                        </nav>
                    </div>
                    <RequestInventory
                        openModal={openModal}
                        handleClosedModal={handleClosedModal}
                        handleOpenModal={handleOpenModal}
                    />


                </div>
            </div>

        </>

    )
}

export default Inventory